import { Component, Output, EventEmitter, Input } from '@angular/core';

import { EditFacSearchProfileModel } from '../../../core/models/edit-fac-modal.model';
import { EditFacModalService } from '../edit-fac-modal/service/edit-fac-modal.service';

@Component({
  selector: 'app-search-profile-card',
  templateUrl: './search-profile-card.component.html',
  styleUrls: ['./search-profile-card.component.scss']
})
export class SearchProfileCardComponent {

  @Input() card: EditFacSearchProfileModel;
  @Input() facId: string;
  @Output() editClick = new EventEmitter<any>();
  @Output() removeClick = new EventEmitter<any>();

  constructor(
    private facModalService: EditFacModalService,
  ) {}

  public linked(data: string) {
    this.facModalService.hrefLink(this.facId, data).subscribe((x: any) => window.open(x.url));
  }

}
